/**
 * @license
 * Copyright Workylab. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/workylab/materialize-angular/master/LICENSE
 */

import { MonthLabels } from '../completed-components/calendar/calendar.model';

export const months: MonthLabels = {
  april: {
    name: 'April',
    shortName: 'Apr',
    shortestName: 'Ap'
  },
  august: {
    name: 'August',
    shortName: 'Aug',
    shortestName: 'Au'
  },
  december: {
    name: 'December',
    shortName: 'Dec',
    shortestName: 'De'
  },
  february: {
    name: 'February',
    shortName: 'Feb',
    shortestName: 'Fe'
  },
  january: {
    name: 'January',
    shortName: 'Jan',
    shortestName: 'Ja'
  },
  july: {
    name: 'July',
    shortName: 'Jul',
    shortestName: 'Ju'
  },
  june: {
    name: 'June',
    shortName: 'Jun',
    shortestName: 'Ju'
  },
  march: {
    name: 'March',
    shortName: 'Mar',
    shortestName: 'Ma'
  },
  may: {
    name: 'May',
    shortName: 'May',
    shortestName: 'Ma'
  },
  november: {
    name: 'November',
    shortName: 'Nov',
    shortestName: 'No'
  },
  october: {
    name: 'October',
    shortName: 'Oct',
    shortestName: 'Oc'
  },
  september: {
    name: 'September',
    shortName: 'Sep',
    shortestName: 'Se'
  }
};
